import { catalogSummaryApi } from 'app/src/services/welfareportal'
import { AdvancedCard } from 'app/src/shared/components'
import { catalogVisibilityFunc } from 'app/src/shared/helpers'
import { useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import favouritesSvg from 'app/static/images/favourites.svg'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function CatalogCategoriesSection({ showFavourites = false }: { showFavourites?: boolean }): ReactElement {
  const { t } = useTranslation('catalog')
  const context = useWebAppContext()
  const navigate = useWelfarePortalNavigate()
  const catalogSummaryDetails = catalogSummaryApi.useCatalogSummaryList({
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  const categories = catalogSummaryDetails?.data?.categories?.filter((item: catalogSummaryApi.CatalogSummaryItem) =>
    catalogVisibilityFunc(item, context, true),
  )

  return (
    <div className='mt-5 grid grid-cols-1 gap-10 md:grid-cols-2 md:py-16 lg:px-0 lg:py-5' data-testid='CatalogCategoriesSection'>
      {/* FavouritesBanner integrato nella grid */}
      {showFavourites && (
        <Card
          data-testid={`CatalogCategoryCard-Favourites`}
          className='flex max-w-[100%] flex-col bg-[var(--card-background)]'
          style={{
            backgroundImage: `url(${favouritesSvg})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right bottom',
          }}
          header={
            <div className='aspect-[3/2] max-h-[220px] w-full'>
              <div className='p-card-title p-4 pb-0'>{t('Catalog.FavouritesBanner.Favourites.Title')}</div>
              <div className='mb-4 flex-grow p-4 text-left text-base font-semibold leading-[20.8px]'>
                {t('Catalog.FavouritesBanner.Favourites.Text')}
              </div>
            </div>
          }
          title={<div>&nbsp;</div>}
          footer={
            <Button
              rounded
              label={t('Catalog.FavouritesBanner.Favourites.ButtonLabel')}
              onClick={() => navigate.goToFavourites()}
            ></Button>
          }
        ></Card>
      )}

      {/* Categorie del catalogo */}
      {categories?.map((card) => {
        if (card.id === 'DISCOUNT') return null
        const navigateF = () => navigate.goToShowcase({ macroCategoryId: card.id })
        return (
          <div key={card.id} className='max-w-[100%]' data-testid={`CatalogCategoryCard-${card.title}`}>
            <AdvancedCard
              onSelection={navigateF}
              title={card.title}
              imageSrc={card.imageSrc}
              className='cursor-pointer'
              footer={<Button rounded label={t('Catalog.CatalogCategories.ButtonLabel')} onClick={navigateF}></Button>}
            />
          </div>
        )
      })}
    </div>
  )
}
